module.exports = __webpack_public_path__ + "img/accounting-annual-tax.c1fae9dd.svg";